import { render } from "./PaymentComplete.vue?vue&type=template&id=5913de78"
import script from "./PaymentComplete.vue?vue&type=script&lang=js"
export * from "./PaymentComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__